export const IN_LABOR = { id: 'in_labor', label: 'In travaglio' };
export const OUT_OF_LABOR = { id: 'out_of_labor', label: 'Fuori travaglio' };
